export { AwardsPageBannerSection } from "./AwardsPageBannerSection";
export { AwardsPageFeedSection } from "./AwardsPageFeedSection";
export { AwardsPageImageSection } from "./AwardsPageImageSection";
export { AwardsPageTextSection } from "./AwardsPageTextSection";
